<template>
  <section class="schedule-section-wrapper">
    <div
      class="schedule-section"
      v-for="chapter in chapterList"
      :class="{
        hasChapter,
        noChapter: !hasChapter
      }"
      :key="chapter.id"
    >
      <div
        class="schedule-section-button"
        :class="{ 'rotate': chapter.isSpread }"
        @click="handleFoldSection(chapter)"
        v-if="chapter.type === 1"
      ></div>
      <div
        class="schedule-section-title"
        @click="handleFoldSection(chapter)"
        v-if="chapter.type === 1"
      >{{ chapter.name }}</div>
      <ul class="schedule-section-list" :class="{ 'spread': chapter.isSpread }">
        <li v-for="section in chapter.sectionList" :key="section.id" @click="handleSelect(section)">
          <!-- <div class="schedule-section-course-timer">08:29</div> -->
          <div class="schedule-section-course-name" :class="{ hasBuy }">
            {{ section.name }}
            <span
              v-if="!hasBuy && section.canTry === 1"
              class="schedule-section-try"
            ></span>
          </div>
          <div class="schedule-section-course-arrow" v-if="hasBuy || section.canTry === 1"></div>
          <div v-if="hasBuy">
            <div
              class="schedule-section-course-status"
              v-if="section.isPublished === 1"
              :class="{
                'orange': section.isFinished === 0 && section.learnLength,
                'green': section.isFinished === 0 && !section.learnLength
              }"
            >{{ section.isFinished | scheduleStatus(section.learnLength, section.videoLength) }}</div>
            <div
              class="schedule-section-course-status"
              v-else
            >更新时间{{ section.publishDate | formatTimestamp }}</div>
          </div>
          <!-- <div class="schedule-section-course-bar">
            <div>学习</div>
            <div>打卡</div>
            <div>作业</div>
          </div>-->
        </li>
      </ul>
    </div>
  </section>
</template>

<script>
import scheduleStatus from '../filters/schedule-status'
import formatTimestamp from '../filters/format-timestamp-to-date'
// eslint-disable-next-line no-unused-vars
import os from '@edu-fe/os'
import { isxxx } from '@mixins'
import Cookie from 'js-cookie'

export default {
  name: 'ScheduleList',

  mixins: [isxxx],

  props: {
    // 引入页面
    page: {
      type: String,
      required: true
    },

    dataSource: {
      type: Object,
      required: true
    },

    hasBuy: {
      type: Boolean,
      default: false
    },
    aiCourse: ''
  },

  computed: {
    // 是否有章节
    hasChapter () {
      return this.dataSource.chapterList[0].type === 1
    },

    chapterList () {
      // 区分带章节的课程和不带章节的
      // 统一修改为章节信息的二维数据结构
      const hasChapter = (this.dataSource.chapterList || []).filter(
        (item) => item.type === 1
      ).length
      const { chapterList = [] } = this.dataSource

      let list = []
      if (!hasChapter) {
        chapterList.forEach((item) => {
          list.push({
            sectionList: [item],
            isSpread: true
          })
        })
      } else {
        chapterList.forEach((item) => {
          if (item.type === 1) {
            item.sectionList = []
            list.push(item)
          } else {
            if (list.length) {
              list[list.length - 1].sectionList.push(item)
            }
          }
        })
      }
      return list
    }
  },

  filters: {
    scheduleStatus,
    formatTimestamp
  },

  methods: {
    handleSelect (chapter) {
      // 未购买且非试看, 不可点击
      if (!this.hasBuy && chapter.canTry !== 1) return
      // eslint-disable-next-line eqeqeq
      if (this.aiCourse && this.aiCourse == 8) {
        this.wxQrCode()
      } else {
        if (chapter.liveState === -1) {
          // 非直播课
          if (chapter.isPublished) {
            // 区分音/视频详情
            switch (chapter.mediaType) {
              case 1: // 视频
                // if (this.isWx) {
                //   window.location.href = `https://edu-m.wps.cn/video-detail?courseId=${this.dataSource.courseId}&chapterId=${chapter.id}&from=${this.$route.query.from}`
                //   return
                // }
                this.$router.push(
                  `/video-detail?courseId=${this.dataSource.courseId}&chapterId=${chapter.id}`
                )
                break
              case 2: // 音频
                // if (this.isWx) {
                //   window.location.href = `https://edu-m.wps.cn/audio-detail?courseId=${this.dataSource.courseId}&chapterId=${chapter.id}&from=${this.$route.query.from}`
                //   return
                // }
                this.$router.push(
                  `/audio-detail?courseId=${this.dataSource.courseId}&chapterId=${chapter.id}`
                )
                break
            }
          }
        } else {
          // 直播课
          this.$router.push(`/live?chapterId=${chapter.id}`)
        }
      }
    },

    wxQrCode (type = '') {
      this.$axios
        .get(
          `https://course.auoktalk.com/api/platform/user/mic/program/qr/code?userId=${Cookie.get(
            'openid'
          )}&courseId=${this.dataSource.courseId}&micProgramAppId=${this.$route.query.micProgramAppId || ''}`
        )
        .then((res) => {
          const {
            data: { data = '' }
          } = res
          sessionStorage.setItem('qrCodeImage', data)
          this.$router.push('wx-service')
        })
    },

    handleFoldSection (section) {
      this.$emit('fold', section)
    }
  }
}
</script>

<style lang="scss" scoped>
@charset 'utf-8';
@import "../style/main";

$global-width: 750;

.schedule-section {
  $padding: rem(30);
  $hasChapter: "";
  $noChapter: "";

  position: relative;
  border-bottom: rem(6) solid #f3f4f6;

  &.hasChapter {
    $hasChapter: & + "";
  }

  &.noChapter {
    $noChapter: & + "";
    border-bottom: none;
  }

  // &-wrapper {
  //   overflow-y: scroll;
  //   height: 100%;
  // }

  // 普通课课程标题
  &-title {
    padding-left: $padding;
    position: relative;
    font-size: rem(28);
    @include height(88);
  }

  // 展开收起按钮
  &-button {
    $size: rem(32);

    transition: transform 0.2s linear;
    transform: rotate(180deg);
    position: absolute;
    top: $padding;
    right: $padding;
    width: $size;
    height: $size;
    background-image: url("../assets/images/schedule-icon-arrow-button.png");
    background-size: contain;

    &.rotate {
      transform: rotate(0);
    }
  }

  // 普通课列表
  &-list {
    overflow: hidden;
    transition: all 0.2s linear;
    transform: scaleY(0);
    transform-origin: 0 0;
    opacity: 0;
    height: 0;
    background-color: #f3f4f6;

    #{$noChapter} & {
      background-color: #fff;
    }

    &.spread {
      transform: scaleY(1);
      opacity: 1;
      height: auto;
    }

    &.white {
      background-color: #fff;
    }

    & > li {
      position: relative;
      // padding: 0 $padding;
      margin-left: $padding;
      border-bottom: 1px solid #e4e4e4;

      &:first-child {
        margin-top: 0;
      }

      &:last-child {
        border-bottom: none;
      }
    }
  }

  &-try {
    color: $globalColor;
    font-size: use(22);
    display: inline-block;
    padding: use(4) use(6);
    box-sizing: border-box;
    border: 1px solid rgba($color: $globalColor, $alpha: 0.5);
    background: rgba($color: $globalColor, $alpha: 0.1);
    line-height: 1;
    border-radius: use(2);
    margin-left: use(16);

    &:before {
      content: "试看";
    }
  }

  // 课程信息
  &-course {
    // &-timer {
    //   position: absolute;
    //   top: 0;
    //   left: 0;
    //   width: rem(74);
    //   height: rem(30);
    //   line-height: rem(30);
    //   border-bottom-right-radius: rem(12);
    //   background-color: #f48f00;
    //   text-align: center;
    //   font-size: rem(22);
    //   color: #fff;
    // }

    &-arrow {
      transform: translateY(-50%) scale(1.1);
      position: absolute;
      top: 50%;
      right: rem(40);
      width: rem(10);
      height: rem(20);
      background-image: url("../assets/images/schedule-icon-arrow.png");
      background-repeat: no-repeat;
      background-size: contain;
    }

    &-name {
      position: relative;
      font-size: rem(28);
      line-height: rem(40);
      padding-right: rem(40);

      padding-top: rem(40);
      padding-bottom: rem(40);
      border-bottom: 1px solid #e4e4e4;
      margin-bottom: -1px;

      &.hasBuy {
        padding-top: rem(20);
        padding-bottom: rem(8);
        border-bottom: none;
        margin-bottom: 0;
      }
    }

    &-status {
      // margin-top: rem(20);
      font-size: rem(24);
      line-height: rem(33);
      color: #999;
      padding-bottom: rem(20);

      &.orange {
        color: #f48f00;
      }

      &.green {
        color: #6bbc55;
      }
    }

    &-bar {
      overflow: hidden;
      position: relative;
      margin-top: rem(30);
      padding: rem(30) rem(30) 0;

      &::before {
        content: "";
        transform: scaleY(0.5);
        transform-origin: 0 1px;
        position: absolute;
        top: 0;
        right: 0;
        left: 0;
        height: 1px;
        background-color: #d7d7d7;
      }

      & > div {
        float: left;
        margin-right: rem(100);
        font-size: rem(24);
        color: #666;

        &:last-child {
          margin-right: 0;
        }

        &::after {
          $size: rem(26);

          content: "";
          display: inline-block;
          vertical-align: middle;
          margin-left: rem(12);
          width: $size;
          height: $size;
          background-image: url("../assets/images/schedule-icon-s.png");
          background-size: contain;
        }
      }
    }
  }
}

$global-width: 720;
</style>
